import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
  viewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Collection } from '../../models';
import { GridColumn, PrimeGridOption } from '@shared/modules/grid/abstractions';
import { PrimeGridComponent } from '@shared/modules/grid/components/prime-grid/prime-grid.component';
import { TranslateService } from '@ngx-translate/core';
import { TaxRulesManagerHeadersService } from '../../services/tax-rules-manager-headers.service';
import { TaxPoliciesManagerService } from '../../services/tax-policies-manager.service';
import { TaxPolicy } from '../../models/tax-policy';
import { TaxPoliciesGrid } from '../../types/tax-policies.type';
import { ActionButton } from '@shared/abstraction/grid/action-button';
import { Router } from '@angular/router';
import { DrawerManagerService } from '@shared/services/drawer/drawer-manager.service';

@Component({
  standalone: false,
  selector: 'gstar-rules-manager-page',
  templateUrl: './rules-manager-page.component.html',
  styleUrl: './rules-manager-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RulesManagerPageComponent implements OnInit {
  private readonly drawerManagerService = inject(DrawerManagerService);
  private readonly translateService = inject(TranslateService);
  private readonly taxPoliciesManager = inject(TaxPoliciesManagerService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly taxRulesManagerHeadersService = inject(
    TaxRulesManagerHeadersService
  );

  taxRules = signal<Collection<TaxPolicy>>({
    total: 0,
    items: [],
  });
  isLoading = signal<boolean>(true);
  headers = signal<GridColumn[]>([]);

  grid = viewChild<PrimeGridComponent<TaxPolicy>>('grid');

  setting: PrimeGridOption<TaxPolicy> = {
    lazy: true,
    emptyMessage: this.translateService.instant(
      'admin.dashboard.notFoundRecordsMessage'
    ),
    hasCheckbox: false,
    actionMenu: (): ActionButton<TaxPolicy>[] => [
      {
        label: 'Edit',
        icon: '',
        command: (_item: TaxPolicy): void => {},
      },
      {
        label: 'View',
        icon: '',
        command: (_item: TaxPolicy): void => {},
      },
    ],
  };

  ngOnInit(): void {
    this.taxPoliciesManager.taxPolicies$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((taxRuleCollection: Collection<TaxPolicy>) => {
        this.taxRules.set(taxRuleCollection);
        this.isLoading.set(false);
      });

    this.headers.set(this.taxRulesManagerHeadersService.getHeaders());
  }

  queryHandler(query: TaxPoliciesGrid): void {
    this.taxPoliciesManager.updateQuery(query);
  }

  addTaxPolicyHandler(): void {}
}
